import { render, staticRenderFns } from "./ChangePriority.vue?vue&type=template&id=0632286e"
import script from "./ChangePriority.vue?vue&type=script&lang=js"
export * from "./ChangePriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports